import { render, staticRenderFns } from "./ImageVideoClip.vue?vue&type=template&id=8d234b52&lang=pug&"
import script from "./ImageVideoClip.vue?vue&type=script&lang=js&"
export * from "./ImageVideoClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports